import { Compass } from "lucide-react";
import { PromotionalCardBase } from "../card-base";
import { PromotionalCardProps } from "../types";

export function ExploreServicesCard({ className }: PromotionalCardProps) {
	return (
		<PromotionalCardBase
			icon={<Compass className="w-full h-full" strokeWidth={1.5} />}
			title="Discover Our Services"
			description="From property search to legal verification & loans — we've got you covered"
			ctaText="Explore Services"
			href="/services"
			className={className}
			iconColor="text-teal-600"
		/>
	);
}
